function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--icon-color, currentColor)"
    },
    d: "M48 34.3087H28.349V23.6779C28.349 18.5235 29.4765 13.8523 31.7315 9.66443C33.9866 5.36913 37.3154 2.14765 41.7181 0L47.1946 4.02684C46.1208 5.10067 45.047 6.1208 43.9732 7.08724C43.0067 8.05369 41.9866 9.02013 40.9128 9.98657C38.6577 12.5638 37.5302 15.302 37.5302 18.2013H48V34.3087ZM19.651 34.3087H0V23.6779C0 18.5235 1.12752 13.8523 3.38255 9.66443C5.63758 5.36913 8.96644 2.14765 13.3691 0L18.8456 4.02684C17.8792 5.10067 16.8591 6.1208 15.7852 7.08724C14.7114 8.05369 13.6376 9.02013 12.5638 9.98657C10.3087 12.7785 9.18121 15.5168 9.18121 18.2013H19.651V34.3087Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.a780d530d7999e7a104922ad0719aca7.svg";
export { ForwardRef as ReactComponent };